import React from 'react';

export const SettingTitle: React.FC<{
  title: string;
  id?: string;
  description?: string;
}> = ({title, id, description}) => {
  return (
    <div className="flex flex-col">
      <div className="pb-2 font-semibold" id={id}>
        {title}
      </div>
      {description && (
        <div className="pt-2 text-sm text-moon-600">{description}</div>
      )}
    </div>
  );
};
